<template>
    <rkm-layout-body title="Lista de permissões">
        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/administracao/permissao/List'

export default {
    components: { List }
}
</script>